/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountDataUpdateLog
 */
export interface AccountDataUpdateLog {
    /**
     * 
     * @type {string}
     * @memberof AccountDataUpdateLog
     */
    accountId: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountDataUpdateLog
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof AccountDataUpdateLog
     */
    updatedBy: string;
    /**
     * 
     * @type {number}
     * @memberof AccountDataUpdateLog
     */
    version?: number | null;
    /**
     * 
     * @type {AccountDataUpdateLogModificationTypeEnum}
     * @memberof AccountDataUpdateLog
     */
    modificationType: AccountDataUpdateLogModificationTypeEnum;
}


/**
 * @export
 */
export const AccountDataUpdateLogModificationTypeEnum = {
    New: 'New',
    Updated: 'Updated',
    Deleted: 'Deleted'
} as const;
export type AccountDataUpdateLogModificationTypeEnum = typeof AccountDataUpdateLogModificationTypeEnum[keyof typeof AccountDataUpdateLogModificationTypeEnum];


/**
 * Check if a given object implements the AccountDataUpdateLog interface.
 */
export function instanceOfAccountDataUpdateLog(value: object): value is AccountDataUpdateLog {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('modificationType' in value) || value['modificationType'] === undefined) return false;
    return true;
}

export function AccountDataUpdateLogFromJSON(json: any): AccountDataUpdateLog {
    return AccountDataUpdateLogFromJSONTyped(json, false);
}

export function AccountDataUpdateLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDataUpdateLog {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'updatedAt': (new Date(json['updatedAt'])),
        'updatedBy': json['updatedBy'],
        'version': json['version'] == null ? undefined : json['version'],
        'modificationType': json['modificationType'],
    };
}

export function AccountDataUpdateLogToJSON(json: any): AccountDataUpdateLog {
    return AccountDataUpdateLogToJSONTyped(json, false);
}

export function AccountDataUpdateLogToJSONTyped(value?: AccountDataUpdateLog | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'updatedAt': value['updatedAt'].toISOString(),
        'updatedBy': value['updatedBy'],
        'version': value['version'],
        'modificationType': value['modificationType'],
    };
}

